<template>
  <div class="form_toolbar clearfix">
    <a-popover placement="bottom">
      <template slot="content">
        <ul class="action_list">
          <template v-for="(item, type) in formType">
            <li
              :key="type"
              @click="addForm(type)"
            >
              {{ formType[type] }}
            </li>
          </template>
        </ul>
      </template>
      <a-button type="primary">
        {{ $t('message["122"]') }}
        <i class="iconfont iconicon-test19" />
      </a-button>
    </a-popover>
    <tool-search :level="level" />
  </div>
</template>

<script type="text/ecmascript-6">
import ToolSearch from './ToolForm'
import { mapState } from 'vuex'
export default {
  components: {
    ToolSearch
  },
  props: {
    level: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState('smart/manage', ['formType']),
    ...mapState(['baseinfo'])
  },
  methods: {
    // 添加表单
    addForm (type) {
      this.$emit('add', { type })
    }
  }
}
</script>

<style scoped lang="scss">
.form_toolbar {
  width: 100%;
  height: 56px;
  margin: 24px auto 0 auto;
  button {
    display: inline-block
  }
}
.action_list {
  li {
    line-height: 24px;
    padding: 4px 12px;
  }
  li:hover {
    cursor: pointer;
    background: #f4f7f9;
    border-radius: 4px;
  }
}
</style>
